import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Calendar, MapPin, ArrowRight, Clock } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const events = [];
export default function UpcomingEvents() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="63192" id="upcoming-hit-list" ref={ref} className={`py-24 bg-[#000000] transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-[#FFFFFF] mb-4">
            Upcoming Hit-List
          </h2>
          <p className="text-[#CCCCCC] font-sans text-lg max-w-2xl mx-auto">Experience the soundtrack of your life performed with passion and precision. Check out where Skin N' Bonez is taking the stage next.<br /><br />Now booking shows, festivals or private events.<div>For bookings or collaborations, reach out at:</div><div>saorcenc@hotmail.com</div></p>
        </div>

        <div className="flex flex-col gap-0">
          {events.map((event, i) => <Card key={i} data-index={i} className="group flex flex-col md:flex-row overflow-hidden border-0 border-b border-[#333333] rounded-none bg-transparent hover:bg-[#111111] transition-colors duration-300 shadow-none">
              {}
              <div className="bg-transparent md:w-32 lg:w-40 flex flex-row md:flex-col items-center justify-center p-4 md:p-6 text-[#FFFFFF] border-b md:border-b-0 md:border-r border-[#333333] shrink-0 gap-3 md:gap-0">
                <span className="text-2xl md:text-3xl font-serif font-bold tracking-tighter">
                  {event.day}
                </span>
                <span className="text-sm md:text-base font-sans font-bold uppercase tracking-widest text-[#FF0000]">
                  {event.month}
                </span>
              </div>

              {}
              <div className="flex-1 p-6 flex flex-col justify-center">
                <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2 mb-3">
                  <h3 className="text-xl font-serif font-bold text-[#FFFFFF] group-hover:text-[#FF0000] transition-colors">
                    {event.title}
                  </h3>
                  <div className="flex flex-wrap gap-3 text-sm text-[#CCCCCC] font-sans">
                    <div className="flex items-center gap-1.5">
                      <Clock className="w-4 h-4 text-[#FF0000]" />
                      <span>{event.time}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <MapPin className="w-4 h-4 text-[#FF0000]" />
                      <span>{event.location}</span>
                    </div>
                  </div>
                </div>

                <p className="text-[#CCCCCC] font-sans mb-5 line-clamp-2">
                  {event.description}
                </p>

                <div className="mt-auto">
                  <Link to={event.link} className="inline-flex items-center text-sm font-bold uppercase tracking-wider text-[#FF0000] hover:text-[#FFFFFF] transition-colors">
                    Venue Website
                    <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
                  </Link>
                </div>
              </div>
            </Card>)}
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" variant="outline" className="border-[#FFFFFF] text-[#FFFFFF] rounded-[4px] font-sans font-bold uppercase tracking-wider hover:bg-[#FF0000] hover:border-[#FF0000] hover:text-white transition-all duration-300">
            <Link to="https://www.facebook.com/SkinNBonezChicago/events" newTab>
              <SafeHydrate><Calendar className="w-4 h-4 mr-2" /></SafeHydrate>
              View Full Schedule
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}